export default class SearchParams {
  public filter?: string;
  public offset?: number;
  public limit?: number;
  public sort?: string;
  public fields?: string;
  public view?: string;
}
